"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _fieldHelper = require("./fieldHelper");
var _FieldTypes = _interopRequireDefault(require("./constants/FieldTypes"));
// Check if value follows a valid readableId pattern for use in JavaScript formulas
// Note to test this please run npm test src/validateReadableId.test.js

// JavaScript reserved words and future reserved words
var JS_RESERVED_WORDS = new Set([
// ES6 Keywords
'break', 'case', 'catch', 'class', 'const', 'continue', 'debugger', 'default', 'delete', 'do', 'else', 'export', 'extends', 'finally', 'for', 'function', 'if', 'import', 'in', 'instanceof', 'new', 'return', 'super', 'switch', 'this', 'throw', 'try', 'typeof', 'var', 'void', 'while', 'with', 'yield',
// ES6 Future Reserved Words
'enum', 'implements', 'interface', 'let', 'package', 'private', 'protected', 'public', 'static', 'await', 'async',
// Literals
'null', 'true', 'false', 'undefined', 'NaN', 'Infinity']);

// Common Excel function names (subset of most commonly used)
var EXCEL_FUNCTIONS = new Set([
// Math functions
'sum', 'average', 'count', 'max', 'min', 'round', 'roundup', 'rounddown', 'ceiling', 'floor', 'abs', 'sign', 'sqrt', 'power', 'exp', 'ln', 'log', 'log10', 'mod', 'quotient', 'product', 'sumif', 'countif', 'averageif', 'sumifs', 'countifs', 'averageifs', 'maxifs', 'minifs', 'subtotal', 'aggregate', 'rand', 'randbetween', 'pi', 'degrees', 'radians', 'fact', 'combin', 'permut', 'gcd', 'lcm', 'mround', 'multinomial', 'seriessum', 'sqrtpi', 'sumproduct', 'sumsq', 'sumx2my2', 'sumx2py2', 'sumxmy2',
// Text functions
'concatenate', 'concat', 'left', 'right', 'mid', 'len', 'lower', 'upper', 'proper', 'trim', 'substitute', 'replace', 'find', 'search', 'text', 'value', 'clean', 'code', 'char', 'exact', 'rept', 'fixed', 'dollar', 'textjoin', 'textbefore', 'textafter', 'textsplit', 'unichar', 'unicode',
// Date functions
'date', 'today', 'now', 'year', 'month', 'day', 'hour', 'minute', 'second', 'weekday', 'weeknum', 'datedif', 'datevalue', 'timevalue', 'days', 'days360', 'edate', 'eomonth', 'networkdays', 'workday', 'isoweeknum', 'yearfrac',
// Logical functions
'if', 'and', 'or', 'not', 'xor', 'iferror', 'ifna', 'ifs', 'switch', 'true', 'false',
// Lookup functions
'vlookup', 'hlookup', 'lookup', 'match', 'index', 'choose', 'offset', 'indirect', 'row', 'column', 'rows', 'columns', 'transpose', 'unique', 'filter', 'sort', 'sortby', 'xlookup', 'xmatch',
// Statistical functions
'median', 'mode', 'stdev', 'var', 'correl', 'forecast', 'trend', 'growth', 'linest', 'logest', 'slope', 'intercept', 'pearson', 'rsq', 'steyx', 'kurt', 'skew', 'rank', 'percentile', 'quartile', 'percentrank', 'large', 'small', 'standardize', 'ztest', 'ttest', 'ftest', 'chisq', 'norm', 'lognorm', 'expon', 'gamma', 'beta', 'binom', 'poisson', 'weibull', 'hypgeom', 'negbinom', 'geomean', 'harmean', 'devsq', 'avedev', 'confidence',
// Financial functions
'pv', 'fv', 'pmt', 'rate', 'nper', 'irr', 'npv', 'mirr', 'xirr', 'xnpv', 'sln', 'syd', 'ddb', 'vdb', 'ipmt', 'ppmt', 'cumipmt', 'cumprinc', 'price', 'yield', 'duration', 'mduration', 'disc', 'intrate', 'received', 'accrint', 'accrintm', 'coupdaybs', 'coupdays', 'coupdaysnc', 'coupncd', 'coupnum', 'couppcd', 'tbilleq', 'tbillprice', 'tbillyield',
// Information functions
'isblank', 'iserror', 'isna', 'isnumber', 'istext', 'islogical', 'isref', 'isformula', 'cell', 'info', 'type', 'na', 'error', 'iseven', 'isodd', 'n', 'sheet', 'sheets',
// Database functions
'dsum', 'daverage', 'dcount', 'dcounta', 'dmax', 'dmin', 'dproduct', 'dstdev', 'dstdevp', 'dvar', 'dvarp', 'dget',
// Engineering functions
'convert', 'bin2dec', 'bin2hex', 'bin2oct', 'dec2bin', 'dec2hex', 'dec2oct', 'hex2bin', 'hex2dec', 'hex2oct', 'oct2bin', 'oct2dec', 'oct2hex', 'complex', 'imabs', 'imaginary', 'imargument', 'imconjugate', 'imcos', 'imdiv', 'imexp', 'imln', 'imlog10', 'imlog2', 'impower', 'improduct', 'imreal', 'imsin', 'imsqrt', 'imsub', 'imsum', 'delta', 'erf', 'erfc', 'gestep', 'besseli', 'besselj', 'besselk', 'bessely',
// Array functions (newer)
'sequence', 'randarray', 'tocol', 'torow', 'wrapcols', 'wraprows', 'take', 'drop', 'expand', 'choosecols', 'chooserows', 'vstack', 'hstack']);

// JavaScript built-in object methods and properties
var JS_BUILTIN_NAMES = new Set([
// Number methods
'parseFloat', 'parseInt', 'isFinite', 'isInteger', 'isNaN', 'isSafeInteger', 'toExponential', 'toFixed', 'toPrecision', 'toString', 'valueOf',
// String methods
'charAt', 'charCodeAt', 'codePointAt', 'concat', 'endsWith', 'includes', 'indexOf', 'lastIndexOf', 'localeCompare', 'match', 'matchAll', 'normalize', 'padEnd', 'padStart', 'repeat', 'replace', 'replaceAll', 'search', 'slice', 'split', 'startsWith', 'substring', 'toLocaleLowerCase', 'toLocaleUpperCase', 'toLowerCase', 'toUpperCase', 'trim', 'trimEnd', 'trimStart', 'length',
// Array methods
'from', 'isArray', 'of', 'concat', 'copyWithin', 'entries', 'every', 'fill', 'filter', 'find', 'findIndex', 'flat', 'flatMap', 'forEach', 'includes', 'indexOf', 'join', 'keys', 'lastIndexOf', 'map', 'pop', 'push', 'reduce', 'reduceRight', 'reverse', 'shift', 'slice', 'some', 'sort', 'splice', 'unshift', 'values',
// Object methods
'assign', 'create', 'defineProperties', 'defineProperty', 'entries', 'freeze', 'fromEntries', 'getOwnPropertyDescriptor', 'getOwnPropertyDescriptors', 'getOwnPropertyNames', 'getOwnPropertySymbols', 'getPrototypeOf', 'hasOwnProperty', 'is', 'isExtensible', 'isFrozen', 'isSealed', 'keys', 'preventExtensions', 'propertyIsEnumerable', 'seal', 'setPrototypeOf', 'values',
// Global properties
'constructor', 'prototype', '__proto__']);

// Custom reserved words from the spec
var CUSTOM_RESERVED_WORDS = new Set([
// Booleans
'checked', 'unchecked', 'enabled', 'disabled', 'on', 'off', 'yes', 'no',
// Self referencing
'current', 'self'

// Note: 'index' is already in EXCEL_FUNCTIONS, so it's not included here to avoid duplicate warnings
]);

// Common JoyDoc properties (based on the codebase analysis)
var JOYDOC_PROPERTIES = new Set(['_id', 'identifier', 'name', 'type', 'files', 'fields', 'pages', 'pageOrder', 'fieldPositions', 'value', 'file', 'field', 'views', 'source', 'template', 'createdOn', 'updatedOn', 'deleted', 'width', 'height', 'rowHeight', 'cols', 'layout', 'presentation', 'padding', 'styles', 'margin', 'rowOrder', 'columnOrder', 'columns', 'rows', 'options', 'required', 'readOnly', 'disabled', 'hidden', 'validation', 'formula', 'format', 'placeholder', 'defaultValue', 'minValue', 'maxValue', 'minLength', 'maxLength', 'pattern', 'title', 'description', 'displayType', 'x', 'y', 'w', 'h']);

// Field types from FieldTypes.js
// Note: These are removed from validation because generateReadableId uses them as prefixes
// e.g., "text1", "number1", etc. The bare field type names should be allowed.

/**
 * Validates if a string can be used as a JavaScript identifier
 * and doesn't conflict with reserved words
 *
 * @param {*} readableId - The ID to validate
 * @returns {boolean} - True if valid, false otherwise
 */
var _default = exports["default"] = function _default(readableId, fields, tableColumns, fieldId) {
  // Must be a non-empty string
  if (typeof readableId !== 'string' || readableId.length === 0) {
    console.warn("validateReadableId: Invalid input - expected non-empty string, got ".concat(typeof readableId === 'string' ? 'empty string' : (0, _typeof2["default"])(readableId)));
    return false;
  }

  // Must not be parseable as a number (but check for Infinity as a special case)
  if (readableId !== 'Infinity' && !isNaN(readableId)) {
    console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - cannot be a numeric value"));
    return false;
  }

  // Must match the pattern: start with letter or underscore, followed by letters, numbers, or underscores
  var identifierPattern = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
  if (!identifierPattern.test(readableId)) {
    if (/^[0-9]/.test(readableId)) {
      console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - identifiers cannot start with a number"));
    } else if (/[^a-zA-Z0-9_]/.test(readableId)) {
      var invalidChars = readableId.match(/[^a-zA-Z0-9_]/g);
      console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - contains invalid characters: ").concat((0, _toConsumableArray2["default"])(new Set(invalidChars)).join(', ')));
    } else {
      console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - must start with a letter or underscore and contain only letters, numbers, and underscores"));
    }
    return false;
  }

  // Convert to lowercase for case-insensitive checking
  var lowercaseId = readableId.toLowerCase();

  // Check in order of precedence:

  // 1. JavaScript reserved words (highest priority)
  if (JS_RESERVED_WORDS.has(readableId) || JS_RESERVED_WORDS.has(lowercaseId)) {
    console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - it's a JavaScript reserved word"));
    return false;
  }

  // 2. JavaScript built-in names
  if (JS_BUILTIN_NAMES.has(readableId)) {
    console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - it's a JavaScript built-in method or property"));
    return false;
  }

  // 3. JoyDoc properties
  if (JOYDOC_PROPERTIES.has(readableId)) {
    console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - it's a JoyDoc property name"));
    return false;
  }

  // 4. Custom reserved words (lower priority than JoyDoc since 'index' can be more specific)
  if (CUSTOM_RESERVED_WORDS.has(lowercaseId)) {
    console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - it's a reserved word (boolean/self-referencing term)"));
    return false;
  }

  // 5. Excel functions (lowest priority since it has many general terms)
  if (EXCEL_FUNCTIONS.has(lowercaseId)) {
    console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - it's an Excel function name"));
    return false;
  }

  //6. Check for duplicates in readableIds

  if (Array.isArray(fields)) {
    //DuplicateId check for fieldIds
    var duplicateField = fields.find(function (field) {
      return field._id === readableId;
    });
    if (duplicateField) {
      console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - it already exists in fields"));
      return false;
    }

    /**
     * DuplicateId check for nested tables of collection fields
     * When readableIds for nestedTables are passed in, we need the fieldId to retrieve the collection fields that houses the nestedTable
     */
    if (fieldId) {
      var targetField = fields.find(function (field) {
        return field._id === fieldId;
      });
      if ((targetField === null || targetField === void 0 ? void 0 : targetField.type) === _FieldTypes["default"].collection) {
        var flattenedSchema = (0, _fieldHelper.flattenSchemaTree)(targetField.schema);
        var readableIdExists = flattenedSchema.some(function (schema) {
          return schema.id === readableId;
        });
        if (readableIdExists) {
          console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - it already exists in fields"));
          return false;
        }
      }
    }
  }

  //DuplicateId check for columnIds
  if (tableColumns && Array.isArray(tableColumns)) {
    var duplicateColumnId = tableColumns.find(function (column) {
      return column._id === readableId;
    });
    if (duplicateColumnId) {
      console.warn("validateReadableId: \"".concat(readableId, "\" is invalid - it already exists in fields"));
      return false;
    }
  }
  return true;
};